import { useSyncExternalStore } from 'react'
import { getActiveSale, ActiveSale } from '../utils/weeklyPromo'

/**
 * The current sale name, checked once a minute. Components only re-render
 * when the name actually changes (e.g. at midnight Eastern on Nov 2).
 */

let state: ActiveSale = getActiveSale()
const listeners = new Set<() => void>()
let timer: number | undefined

function check() {
  const next = getActiveSale()
  if (next.name !== state.name) {
    state = next
    listeners.forEach((listener) => listener())
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  if (timer === undefined) {
    check()
    timer = window.setInterval(check, 60000)
  }
  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && timer !== undefined) {
      window.clearInterval(timer)
      timer = undefined
    }
  }
}

export function useActiveSale(): ActiveSale {
  return useSyncExternalStore(subscribe, () => state, () => state)
}
